<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('paymentAdjustment.pageTitle') }}</h1>
      <ts-breadcrumb
        :items="[
          { text: $t('toHomePage'), href: '/' },
          {
            text: $t('paymentAdjustment.pageTitle'),
            active: true
          }
        ]"
      />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <div class="d-flex justify-content-between">
          <ts-button outline color="info" @click="addNew">{{
            $t('add_new')
          }}</ts-button>
          <div class="d-flex">
            <ts-input
              v-model="search"
              :placeholder="$t('search')"
              style="width: 250px"
              class="inline-block"
            />
            <ts-button
              outline
              class="ml-2"
              v-tooltip="$t('filter')"
              @click.prevent="visible = true"
            >
              <i class="fa fa-filter"></i>
            </ts-button>
            <!-- drawer -->
            <a-drawer
              :title="$t('invoice.filter')"
              placement="right"
              :closable="false"
              :visible="visible"
              @close="() => (visible = false)"
              :zIndex="1020"
              width="300px"
            >
              <div class="row">
                <div class="col-md-12">
                  <div class="form-group">
                    <a-select
                      style="width: 257px"
                      v-model="branch_id"
                      :options="branchs"
                      showSearch
                      mode="multiple"
                      :filterOption="
                        (input, option) =>
                          option.componentOptions.children[0].text
                            .toLowerCase()
                            .indexOf(input.toLowerCase()) >= 0
                      "
                      :maxTagCount="1"
                      :maxTagTextLength="17"
                      :placeholder="$t('all')"
                    >
                    </a-select>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <div class="form-group">
                    <a-range-picker
                      format="DD-MM-YYYY"
                      :defaultValue="rangeDate"
                      :defaultPickerValue="rangeDate"
                      @change="dateRangeChange"
                    >
                      <template slot="renderExtraFooter"></template>
                    </a-range-picker>
                  </div>
                </div>
              </div>
            </a-drawer>
          </div>
        </div>
      </ts-card-wrapper>
      <div class="overflow-auto">
        <ts-table
          :columns="columns"
          :records="resources"
          :loading="loading"
          :rowGroup="{
            field: 'branch.branch_name_en'
          }"
        >
          <template v-slot="{ record }">
            <td>{{ record.adj_date }}</td>
            <td>{{ record.adj_number }}</td>
            <td>{{ record.invoice.inv_number }}</td>
            <td>{{ record.invoice.student.card_number }}</td>
            <td>{{ record.invoice.student.full_name_en }}</td>
            <td>{{ record.invoice.student.gender }}</td>
            <td class="text-center">{{ record.adj_amount }}</td>
            <td>{{ record.descriptions }}</td>
            <td class="ts-whitespace-no-wrap text-center">
              <a
                href="#"
                class="text-red mr-2"
                @click.prevent="viewPdf(record)"
              >
                <i class="fa fa-file-pdf"></i>
              </a>
              <a href="#" class="text-primary" @click.prevent="edit(record)">
                <i class="fas fa-eye"></i>
              </a>
              <a
                href="#"
                @click.prevent="deleteRecord(record)"
                :disabled="record._deleting"
              >
                <i
                  class="fas fa-circle-notch spin ml-2"
                  v-if="record._deleting"
                ></i>
                <i class="fa fa-trash ml-2 text-red" v-else></i>
              </a>
            </td>
          </template>
        </ts-table>
      </div>
      <div class="d-flex justify-content-end p-15">
        <ts-pagination
          v-model="pagination"
          @navigate="fetchData"
        ></ts-pagination>
      </div>
    </ts-card>
    <a-modal
      width="50%"
      centered
      v-model="print_pdf"
      :title="$t('pdf')"
      :maskClosable="false"
      :footer="null"
      :zIndex="1020"
      @cancel="closePDFmodal"
    >
      <pdf-preview :src="src" :waiting="waiting" height="70vh" mspin="30vh" />
    </a-modal>
  </div>
</template>

<script>
import PdfPreview from './components/pdf_preview'
import Reason from './components/reason_delete'
import moment from 'moment'
import { Errors } from 'form-backend-validation'
import { mapState, mapActions } from 'vuex'
import { debounce } from 'lodash'

export default {
  name: 'paymentAdjustment',
  components: {
    PdfPreview,
    Reason
  },
  data () {
    return {
      loading: false,
      visible: false,
      waiting: false,
      src: null,
      print_pdf: false,
      errors: new Errors(),
      deleleErrors: new Errors(),
      rangeDate: [moment(), moment()],
      branchs: [],
      model: {
        adjustment_id: 0,
        adj_date: moment(),
        inv_id: null,
        adj_amount: null,
        descriptions: null
      },
      modelDelete: {
        delete_reason: null
      }
    }
  },
  created () {
    this.branch_id = [this.$store.state.authUser.default_branch_id]
    this.fetchData()
    this.getBranch()
  },
  computed: {
    ...mapState('paymentAdjustment', ['resources', 'pagination']),
    search: {
      get () {
        return this.$store.state.paymentAdjustment.search
      },
      set (newValue) {
        this.$store.commit('paymentAdjustment/SET_SEARCH', newValue)
        this.$store.commit('paymentAdjustment/RESET_CURRENT_PAGE')
      }
    },
    branch_id: {
      get () {
        return this.$store.state.paymentAdjustment.branch_id
      },
      set (newValue) {
        this.$store.commit('paymentAdjustment/SET_BRANCH_ID', newValue)
      }
    },
    columns () {
      return [
        { name: this.$t('paymentAdjustment.date') },
        { name: this.$t('paymentAdjustment.adjustmentNumber') },
        { name: this.$t('paymentAdjustment.invoiceNumber') },
        { name: this.$t('paymentAdjustment.cardNumber') },
        { name: this.$t('paymentAdjustment.studentName') },
        { name: this.$t('paymentAdjustment.sex') },
        {
          name: this.$t('paymentAdjustment.amount'),
          style: 'text-align:center'
        },
        { name: this.$t('paymentAdjustment.description') },
        { name: this.$t('actions'), style: 'text-align:center; width:7%' }
      ]
    }
  },
  methods: {
    ...mapActions('paymentAdjustment', ['destroy', 'printPdf']),
    fetchData (attributes) {
      this.loading = true
      this.$store
        .dispatch(
          'paymentAdjustment/fetch',
          Object.assign(
            {
              branch_id: this.branch_id
            },
            { ...attributes }
          )
        )
        .then(() => {
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          this.$toasted.error(error.message)
        })
    },
    getBranch () {
      this.$store
        .dispatch('user/getBranch', {
          filter: {
            user_branches: true
          }
        })
        .then(response => {
          this.branchs = response.data.map(el => ({
            value: el.branch_id,
            label: el.branch_name_en
          }))
        })
    },
    deleteRecord (record) {
      this.modelDelete.delete_reason = null
      this.$confirm({
        title: this.$t('are_you_sure_to_delete'),
        content: h =>
          h(Reason, {
            props: {
              value: this.modelDelete,
              validate: this.deleleErrors,
              placeholder: this.$t('paymentAdjustment.leaveReason')
            }
          }),
        okText: this.$t('yes'),
        okType: 'danger',
        cancelText: this.$t('no'),
        onOk: () => {
          return this.destroy({
            id: record.adjustment_id,
            data: this.modelDelete
          })
            .then(response => {
              this.$toasted.success(response.message)
              this.fetchData()
              return Promise.resolve(response)
            })
            .catch(error => {
              this.$toasted.error(error.message)
              this.deleleErrors = new Errors(error.errors)
              return Promise.reject(error)
            })
        },
        onCancel () {}
      })
    },
    edit (record) {
      this.$router.push({
        name: 'payment-adjustment-edit',
        params: { id: record.adjustment_id }
      })
    },
    viewPdf (record) {
      this.print_pdf = true
      this.waiting = true
      this.printPdf(record.adjustment_id)
        .then(response => {
          this.src = response.url
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.waiting = false
        })
    },
    addNew () {
       this.$router.push({ name: 'v2-invoice-adjustment-create' })
    },
    clearInput () {
      ;(this.model.adj_date = moment()),
        (this.model.inv_id = null),
        (this.model.adj_amount = null),
        (this.model.descriptions = null)
      this.errors = new Errors()
    },
    dateRangeChange (dateRange) {
      this.$store.commit(
        'paymentAdjustment/SET_DATE_FROM',
        dateRange[0].format('DD-MM-YYYY')
      )
      this.$store.commit(
        'paymentAdjustment/SET_DATE_TO',
        dateRange[1].format('DD-MM-YYYY')
      )
      this.fetchData()
    },
    closePDFmodal () {
      this.print_pdf = false
      this.src = null
    }
  },
  watch: {
    search: debounce(function (search) {
      this.fetchData({ search, branch_id: this.branch_id })
    }, 500),
    branch_id: debounce(function (value) {
      this.fetchData({ branch_id: value })
    }, 500)
  },
  beforeRouteLeave (to, from, next) {
    this.$store.commit('paymentAdjustment/RESET_STATE')
    next()
  }
}
</script>
